import useCurrentIndustry from "@/hooks/globalapis/useCurrentIndustry";
import EducationChildOverview from "../education/nicheSideRoutes/components/education-child/EducationChildOverview";
import VideoProductionChildOverview from "../videoProduction/nicheSideRoutes/components/video-child/VideoProductionChildOverview";
import AcademyChildOverview from "../academy/nicheSideRoutes/components/academy-child/AcademyChildOverview";

export default function useIndexChilOverview() {
  const { industry } = useCurrentIndustry();

  if (industry?.id === 1) {
    return <EducationChildOverview />;
  }

  if (industry?.id === 4) {
    return <VideoProductionChildOverview />;
  }

  if (industry?.id === 5) {
    return <AcademyChildOverview />;
  }

  return <div>Industry Child Overview Not Found</div>;
}
